import {useRef} from 'react';
import DeltaHelper from '@/services/delta/DeltaHelper';
import momentSecondsSince from '@/utils/momentSecondsSince';

type ScreenPresentedEventParams = {
  screen_name: string;
  source: string;
  screen_presentation_id?: string;
  trigger_flow_id?: string;
  trigger_flow_name?: string;
  tab?: string;
};

type ScreenDismissedEventParams = {
  screen_name: string;
  destination: string;
  screen_presentation_id?: string;
  tab?: string;
};

function useTrackScreenEvent() {
  const presentedAtRef = useRef<Date | null>(null);
  const presentationIdRef = useRef<string>('');

  const presented = ({
    screen_name,
    source,
    screen_presentation_id,
    trigger_flow_id = '',
    trigger_flow_name = '',
    tab = '',
  }: ScreenPresentedEventParams) => {
    DeltaHelper.screenPresented(screen_name, source, {
      ...(screen_presentation_id ? {screen_presentation_id} : {}),
      trigger_flow_id,
      trigger_flow_name,
      tab,
    });

    const activeScreen = DeltaHelper.getActiveScreenPresented();
    presentedAtRef.current = activeScreen.presented_at_timestamp || new Date();
    presentationIdRef.current =
      activeScreen.screen_presentation_id || screen_presentation_id || '';
  };

  const dismissed = ({
    screen_name,
    destination,
    screen_presentation_id,
    tab = '',
  }: ScreenDismissedEventParams) => {
    const resolvedPresentationId =
      presentationIdRef.current || screen_presentation_id;
    DeltaHelper.screenDismissed(screen_name, destination, {
      ...(resolvedPresentationId
        ? {screen_presentation_id: resolvedPresentationId}
        : {}),
      session_duration_since_presented: presentedAtRef.current
        ? momentSecondsSince(presentedAtRef.current).toString()
        : '',
      tab,
    });

    presentedAtRef.current = null;
    presentationIdRef.current = '';
  };

  return {presented, dismissed};
}

export default useTrackScreenEvent;
